{
  "$id": "module://fee",
  "$schema": "wealthlane://schemas/domain",
  "title": "SEC Fee",
  "description": "SEC fee create and update payload",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "effectiveDate": {
      "type": "string",
      "title": "Effective Date",
      "widget": "date"
    },
    "rate": {
      "type": "number",
      "title": "Rate ($)",
      "widget": "number",
      "minimum": 0,
      "inputPrecision": 4,
      "displayPrecision": 4
    }
  }
}
